import React from 'react';

import BSImage from 'assets/images/performanceRefresh/filterRecommendation/filter-recommandation-BS.jpg';
import BSImageWebp from 'assets/images/performanceRefresh/filterRecommendation/filter-recommandation-BS.jpg?as=webp';

import BBImage from 'assets/images/performanceRefresh/filterRecommendation/filter-recommandation-BB.jpg';
import BBImageWebp from 'assets/images/performanceRefresh/filterRecommendation/filter-recommandation-BB.jpg?as=webp';

import CCImage from 'assets/images/performanceRefresh/filterRecommendation/filter-recommandation-CC.jpg';
import CCImageWebp from 'assets/images/performanceRefresh/filterRecommendation/filter-recommandation-CC.jpg?as=webp';

import RPImage from 'assets/images/performanceRefresh/filterRecommendation/filter-recommandation-RP.jpg';
import RPImageWebp from 'assets/images/performanceRefresh/filterRecommendation/filter-recommandation-RP.jpg?as=webp';

const FilterRecommendationStatic = {
  BS: {
    color: '#FFCA0C',
    label: 'I want to conquer allergies',
    image: {
      src: BSImage,
      srcWebp: BSImageWebp,
    },
    description: (

      <p>
        Grab our
        {' '}
        <strong>Big Sneeze filter</strong>
        , set Mila into
        {' '}
        <strong>Max Filtration</strong>
        , and pay attention to her
        {' '}
        <strong>pollen alerts</strong>
        . You’ll feel like a brand new breather.
      </p>
    ),
    cleanAir: (
      <>
        416 Clean Air
        {' '}
        <br />
        Delivery Rate (m³/hr)
      </>
    ),
    hepa: (
      <>
        99.97% Efficiency
        <br />
        H13 HEPA Filter
      </>
    ),
    carbon: '',
    link: 'https://milacares.com/buy',
  },

  CC: {
    color: '#F42C52',
    label: 'I want to fight pet dander',
    image: {
      src: CCImage,
      srcWebp: CCImageWebp,
    },
    description: (
      <p>
        Get the
        {' '}
        <strong>Critter Cuddler filter</strong>
        {' '}
        and activate Mila’s
        {' '}
        <strong>Housekeeping Mode</strong>
        {' '}
        for regular deep cleans. It’s the
        secret to happier pet parenting.
      </p>
    ),
    cleanAir: (
      <>
        350 Clean Air
        {' '}
        <br />
        Delivery Rate (m³/hr)
      </>
    ),
    hepa: (
      <>
        99.97% Efficiency
        {' '}
        <br />
        H13 HEPA Filter
      </>
    ),
    carbon: <>75.60% Ammonia Removal Rate</>,
    link: 'https://milacares.com/buy',
  },
  BB: {
    color: '#90989B',
    label: 'I want to sleep better',
    image: {
      src: BBImage,
      srcWebp: BBImageWebp,
    },
    description: (
      <p>
        Get the
        {' '}
        <strong>Basic Breather filter</strong>
        {' '}
        and activate Mila’s
        {' '}
        <strong>Sleep Mode</strong>
        {' '}
        or
        {' '}
        <strong>Whitenoise Mode</strong>
        . You’ll soon be snoozing like a grown-up baby.
      </p>
    ),
    cleanAir: (
      <>
        460 Clean Air
        <br />
        Delivery Rate (m³/hr)
      </>
    ),
    hepa: (
      <>
        99.96% Efficiency
        <br />
        {' '}
        H12 HEPA Filter
      </>
    ),

    carbon: '',
    link: 'https://milacares.com/buy',
  },
  BB_2: {
    color: '#90989B',
    label: 'I want  to feel healthier',
    image: {
      src: BBImage,
      srcWebp: BBImageWebp,
    },
    description: (
      <p>
        Get the
        {' '}
        <strong>Basic Breather filter</strong>
        {' '}
        and activate any of
        Mila’s
        {' '}
        <strong>Automagic Modes</strong>
        . You can’t see air, but you’ll
        feel the difference.
      </p>
    ),
    cleanAir: (
      <>
        460 Clean Air
        <br />
        Delivery Rate (m³/hr)
      </>
    ),
    hepa: (
      <>
        99.6% Efficiency
        {' '}
        <br />
        H12 HEPA Filter
      </>
    ),
    carbon: '',
    link: 'https://milacares.com/buy',
  },
  RP: {
    color: '#8852F6',
    label: 'I want to protect my littles',
    image: {
      src: RPImage,
      srcWebp: RPImageWebp,
    },
    description: (

      <p>
        Get the
        {' '}
        <strong>Rookie Parent filter</strong>
        , set Mila’s Performance Profile on
        {' '}
        <strong>Moderate</strong>
        , and pay attention to her
        {' '}
        <strong>outdoor AQI alerts</strong>
        . It’s the ultimate healthy parenting hack.
      </p>
    ),
    cleanAir: (
      <>
        386 Clean Air
        {' '}
        <br />
        Delivery Rate (m³/hr)
      </>
    ),
    hepa: (
      <>
        99.6% Efficiency
        {' '}
        <br />
        {' '}
        H12 HEPA Filter
      </>
    ),
    carbon: (
      <>
        74.85% VOC
        {' '}
        <br />
        {' '}
        Removal Rate
      </>
    ),
    link: 'https://milacares.com/buy',
  },
};

export default FilterRecommendationStatic;
